export default "/_next/static/images/elisa-muntoni-48fe4af3345ff469ba4941a2e60a8a07.png";